import styled from 'styled-components'

export const InputRangeScaleContainer = styled.div`
  height: 15px;
  width: 100%;
  margin: 4px 0;
`

InputRangeScaleContainer.displayName = 'InputRangeScaleContainer'
